document.documentElement.classList.remove("no-js");

const searchPanel = document.querySelector("[data-search-panel]");
const searchInput = searchPanel?.querySelector("input[type='search']");
let searchTrigger;
const openSearch = () => {
  if (!searchPanel) return;
  searchTrigger = document.activeElement;
  closeNavigation();
  searchPanel.hidden = false;
  document.body.classList.add("overlay-open");
  window.setTimeout(() => searchInput?.focus(), 0);
};
const closeSearch = (restoreFocus = false) => {
  if (!searchPanel) return;
  const wasOpen = !searchPanel.hidden;
  searchPanel.hidden = true;
  document.body.classList.remove("overlay-open");
  if (restoreFocus && wasOpen) searchTrigger?.focus();
};

document.querySelector("[data-search-open]")?.addEventListener("click", openSearch);
document.querySelector("[data-search-close]")?.addEventListener("click", () => closeSearch(true));
searchPanel?.addEventListener("click", (event) => { if (event.target === searchPanel) closeSearch(true); });
searchPanel?.addEventListener("keydown", (event) => {
  if (event.key !== "Tab" || searchPanel.hidden) return;
  const items = [...searchPanel.querySelectorAll('input,button,a[href]')].filter((item) => !item.disabled);
  if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1)?.focus(); }
  else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0]?.focus(); }
});

const siteHeader = document.querySelector("[data-site-header]");
const primaryNav = document.querySelector("[data-primary-nav]");
const mobileMenuButton = document.querySelector("[data-mobile-menu]");
const navGroups = [...document.querySelectorAll("[data-nav-group]")];
const headerHelp = document.querySelector("[data-header-help]");
const contactPanel = document.querySelector("[data-contact-panel]");
const openContactPanel = () => {
  if (!contactPanel) return;
  contactPanel.open = true;
  headerHelp?.removeAttribute("open");
  contactPanel.scrollIntoView({ block: "start", behavior: "auto" });
};
const closeNavigation = () => {
  document.body.classList.remove("mobile-nav-open");
  primaryNav?.classList.remove("is-open");
  mobileMenuButton?.setAttribute("aria-expanded", "false");
  navGroups.forEach((group) => { group.open = false; });
};

mobileMenuButton?.addEventListener("click", () => {
  if (!primaryNav) return;
  const willOpen = !primaryNav.classList.contains("is-open");
  if (willOpen) closeSearch();
  document.body.classList.toggle("mobile-nav-open", willOpen);
  primaryNav.classList.toggle("is-open", willOpen);
  mobileMenuButton.setAttribute("aria-expanded", String(willOpen));
});

navGroups.forEach((group) => {
  group.addEventListener("toggle", () => {
    if (!group.open) return;
    headerHelp?.removeAttribute("open");
    navGroups.forEach((otherGroup) => { if (otherGroup !== group) otherGroup.open = false; });
  });
});

headerHelp?.addEventListener("toggle", () => {
  if (headerHelp.open) closeNavigation();
});
headerHelp?.addEventListener("click", (event) => {
  if (event.target.closest("a")) headerHelp.removeAttribute("open");
});

primaryNav?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeNavigation));
document.addEventListener("click", (event) => {
  const contactLink = event.target.closest('a[href$="#ContactSupport"]');
  if (contactLink && contactPanel) {
    const destination = new URL(contactLink.href, window.location.href);
    if (destination.origin === window.location.origin && destination.hash === "#ContactSupport") {
      event.preventDefault();
      closeNavigation();
      openContactPanel();
      contactPanel.querySelector("input:not([type='hidden'])")?.focus({ preventScroll: true });
    }
  }
  if (siteHeader && !siteHeader.contains(event.target)) {
    closeNavigation();
    headerHelp?.removeAttribute("open");
  }
});
window.matchMedia("(min-width: 1181px)").addEventListener("change", event => {
  if (event.matches) closeNavigation();
});

if (window.location.hash.startsWith("#ContactSupport")) openContactPanel();

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    const helpWasOpen = headerHelp?.open;
    const searchWasOpen = searchPanel && !searchPanel.hidden;
    const openGroup = navGroups.find((group) => group.open);
    const menuWasOpen = primaryNav?.classList.contains("is-open");
    closeSearch(true);
    closeNavigation();
    headerHelp?.removeAttribute("open");
    if (!searchWasOpen) {
      if (helpWasOpen) headerHelp.querySelector("summary")?.focus();
      else if (menuWasOpen) mobileMenuButton?.focus();
      else openGroup?.querySelector("summary")?.focus();
    }
  }
});

document.querySelectorAll(".quick-add-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const button = form.querySelector("button[type='submit']");
    if (!button || button.disabled) return;
    const originalLabel = button.textContent;
    let feedback = form.querySelector('[data-cart-feedback]');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.dataset.cartFeedback = '';
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      form.append(feedback);
    }
    feedback.textContent = '';
    button.disabled = true;
    button.textContent = button.dataset.addingLabel || originalLabel;
    try {
      const response = await fetch(form.action, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      if (!response.ok) throw new Error("Could not add item");
      button.textContent = button.dataset.addedLabel || originalLabel;
      feedback.textContent = button.dataset.addedLabel || originalLabel;
      try {
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll(".cart-button span").forEach((count) => { count.textContent = cart.item_count; });
        }
      } catch {}
      window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1400);
    } catch {
      feedback.textContent = button.dataset.errorLabel || originalLabel;
      button.textContent = originalLabel;
      button.disabled = false;
    }
  });
});
